import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";

import IconButton from "@material-ui/core/IconButton";

import SearchIcon from "@material-ui/icons/Search";

export default function TabSearchbar(props) {
  const { onChange, value } = props;
  const classes = useStyles();

  return (
    <Paper className={classes.root}>
      <IconButton className={classes.iconButton} aria-label="menu">
        <SearchIcon htmlColor="#808080" />
      </IconButton>

      <InputBase
        type="text"
        value={value}
        className={classes.input}
        onChange={onChange}
        placeholder="Search coins"
        inputProps={{
          "aria-label": "Search coins",
          maxLength: 20,
          // pattern: "^[a-zA-Z0-9_.-]*$",
        }}
        // InputProps={{
        //   classes: { root: classes.textFieldStyles },
        //   inputProps: { "aria-label": "Search coins", maxLength: 5 },
        // }}
      />
    </Paper>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: "0px 0px", //2px 0px
    backgroundColor: theme.palette.type === "dark" ? "#141828" : "white",
    border: `1px solid ${theme.palette.text.disabled}`,
    borderRadius: 100,
  },
  input: {
    marginLeft: theme.spacing(2),
    flex: 1,
    color: theme.palette.text.primary,
  },
  iconButton: {
    padding: 0, //5
    paddingLeft: 10, //10
  },
  divider: {
    height: "54px",
    background: theme.palette.text.disabled,
  },
}));
